import styled from 'styled-components'

/**
 * ButtonContainer — reusable footer action row.
 *
 * Right-aligned flex row with consistent gap + a top border. Used as the
 * footer of forms, dialogs, drawers, and similar containers where a row
 * of action buttons sits at the bottom.
 *
 * @example
 *   <ButtonContainer>
 *     <Button variant="secondary" onClick={onCancel}>Cancel</Button>
 *     <Button variant="primary" onClick={onSave}>Save</Button>
 *   </ButtonContainer>
 */
export const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: var(--space-3);
  padding-top: var(--space-6);
  border-top: 1px solid var(--neutral-300);
`
